import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
    getAIPdfList(params) { //获取订单列表
        // const url =  baseURL + '/tbPdfConversionRecord/getAllList';
        const url =  baseURL + '/tbPdfTransformationRecord/list'; // 20260709 修改 wuliang\fanshuangshuang
        return axios.post(url, qs.stringify(params));
    },
}



// WEBPACK FOOTER //
// ./src/api/AIPdf.js